import { render, staticRenderFns } from "./ExecutiveDocsComposite.vue?vue&type=template&id=63adfb29"
import script from "./ExecutiveDocsComposite.vue?vue&type=script&lang=ts"
export * from "./ExecutiveDocsComposite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports